import Vue from 'vue';

// 判断是否涉及端踢下线的权限变更 涉及则弹框提示
// 根据原LBF模块 qidian.sites.mng.org.Privileges.TerminalPriCheck 编写
// 原调用示例：TerminalPriCheck.isChange('modUser', JSON.parse(finalPostData.data), cb);
function changeConfirm(status, cb, cancelCb) {
    // 提示根据status的值有两种情况的提示文案
    let title = '';
    if (status === 1) {
        title = '保存后，相关员工需重新登录客户端';
    } else if (status === 2) {
        title = '保存后，员工可能需重新登录客户端';
    }

    const dialog = Vue.prototype.$confirm({
        title,
        confirmText: '仍然保存',
        confirm() {
            if (cb) {
                cb();
            }
        },
        cancel() {
            if (cancelCb) {
                cancelCb();
            }
        },

        close() {
            if (cancelCb) {
                cancelCb();
            }
        },
    });

    dialog.$el.style.zIndex = 9999;
}

export default function (cginame, originData, cb, cancelCb) {
    const reqData = {
        ...originData,
        cginame,
    };

    Vue.prototype.$ajax
        .write('/mng/org/changeTerminalPrivilegesDetection', reqData)
        .then((res) => {
            let { prompt_status: promptStatus } = res || {};
            promptStatus = Number(promptStatus);

            if (promptStatus === 1 || promptStatus === 2) {
                changeConfirm(promptStatus, cb, cancelCb);
            } else if (cb) {
                cb();
            }
        })
        .catch((error) => {
            Vue.$message.error(error && error.message);
        });
}
